export default __webpack_public_path__ + "static/B0243-bcb63306fb47d86dac60195f4f9316ee.png";